import React from 'react';
import { TableRow, TableCell } from '@mui/material';
import Empty from '../../Empty';
var TableEmpty = function (_a) {
    var colSpan = _a.colSpan, desc = _a.desc, src = _a.src;
    return (React.createElement(TableRow, null,
        React.createElement(TableCell, { colSpan: colSpan, align: "center" },
            React.createElement(Empty, { desc: desc, src: src }))));
};
export default TableEmpty;
